<template>
  <div class="menu-item">
    
    <CallFlowMenu
      :callMenu="callMenu"
      :onEditRecording="onEditRecording"
      :onEditNumbers="onEditNumbers"
      :onDeleteCallMenu="onDeleteCallMenu"
      @select-action="onSelect"
      :target="target"
      :type="type"
      :team="fullTeam"
      :groups="groups"
    />
      <div class="buttons-container">
      <div v-for="(item, index) in callMenu.numbers" :key="item.uniqKey" class="call-menu-button-container">
        <div
          class="call-menu-button"
          :style="{ marginTop: `${topHeight}px` }"
          :class="item.action ? item.action : 'empty_route'"
        >
          <div
            v-if="callMenu.numbers.length % 2 === 0 || (callMenu.numbers.length + 1) / 2 - 1 !== index"
            class="connect-line"
            :class="{ 'revert-direct': index >= (callMenu.numbers.length - 1) / 2 }"
          >
            <svg
              :width="viewPortWidth(index)"
              :height="topHeight"
              :viewBox="`0 0 ${viewPortWidth(index)} ${topHeight}`"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                :d="
                  `M2 ${topHeight} l0 -${firstCurveHeight(index)} q0 -10 10 -10 l${viewPortWidth(index) -
                    24} 0 q10 0 10 -10 l0 -10 l0 -${topHeight - firstCurveHeight(index)}`
                "
                :stroke="lineColor(index)"
                stroke-width="1.5"
              />
            </svg>
          </div>
          <div v-else class="connect-line">
            <svg
              width="2"
              :height="topHeight"
              :viewBox="`0 0 2 ${topHeight}`"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path :d="`M1 ${topHeight} l0 -${topHeight}`" :stroke="lineColor(index)" stroke-width="1.5" />
            </svg>
          </div>
          <p class="button-number">
            {{ item.key }}
          </p>
        </div>
        <svg width="16" height="33" viewBox="0 0 16 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line
            x1="7.97852"
            y1="0.835144"
            x2="7.97851"
            y2="29.3351"
            :stroke="lineColor(index)"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M7.21818 31.0939C7.61853 31.597 8.38281 31.597 8.78316 31.0939L13.6061 25.033C14.1274 24.3779 13.6609 23.4104 12.8236 23.4104H3.17775C2.34045 23.4104 1.87391 24.3779 2.39526 25.033L7.21818 31.0939Z"
            :fill="lineColor(index)"
          />
        </svg>
        <call-flow-button
          :callMenu="true"
          :callMenuNumber="item.key"
          :action="item.action"
          :target="item.target"
          :type="type"
          :team="fullTeam"
          :groups="groups"
          @select-action="onSelect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CallFlowMenu from './CallFlowMenu';
import CallFlowButton from './CallFlowButton';

export default {
  name: 'CallMenuItem',
  components: { CallFlowMenu, CallFlowButton },
  props: {
    callMenu: Object,
    type: String,
    target: "target",
    data: "data"
  },
  computed: {
    ...mapGetters({
      groups: 'auth/getUserGroups',
      fullTeam: 'auth/getUserFullTeam'
    }),
    topHeight() {
      const len = this.callMenu.numbers.length;
      return 15 + 10 * (len / 2);
    }
  },
  methods: {
    onSelect(action, data, type, callMenuNumber,  isTarget = false, isMenu=false) {


     
      if(callMenuNumber){
       
        return this.$emit('select-action', action, data, type, callMenuNumber, isTarget, isMenu);

      }
      else{
        
        return this.$emit('select-action', action, data, this.type, false, isTarget, isMenu);
      }
    },
    
    onEditRecording() {
      return this.$emit('edit-call-menu-recording', this.type);
    },
    onEditNumbers() {
      return this.$emit('edit-call-menu-numbers', this.type);
    },
    onDeleteCallMenu() {
      return this.$emit('delete-call-menu', this.type);
    },
    lineColor(index) {
      switch (this.callMenu.numbers[index].action) {
        case 'route_person':
          return '#819f77';
        case 'route_group':
          return '#77a5d7';
        case 'voicemail':
          return '#6d67ac';
        case 'hang_up':
          return '#cc2f2f';
        default:
          return '#606C82';
      }
    },
    viewPortWidth(index) {
      const len = this.callMenu.numbers.length;
      let wid;
      if (index < len / 2) {
        wid = (len / 2 - index - 1) * (40 + 25 / 2) + (45 / 2 + 10);
      } else {
        wid = (index - len / 2) * (40 + 25 / 2) + (45 / 2 + 10);
      }
      return wid;
    },
    firstCurveHeight(index) {
      const len = this.callMenu.numbers.length;
      let hei;
      if (index < len / 2) {
        hei = (len / 2 - index - 1) * 10;
      } else {
        hei = (index - len / 2) * 10;
      }
      return hei;
    }
  }
};
</script>

<style scoped lang="scss">
.menu-item {
  padding-top: 5px;

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .call-menu-button-container {
      position: relative;
      width: 45px;
      justify-content: flex-start;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 40px;
      &:first-of-type {
        margin-left: 0;
      }
    }
    .call-menu-button {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      position: relative;

      .connect-line {
        position: absolute;
        bottom: 90%;
        left: 19px;

        &.revert-direct {
          left: unset;
          right: 19px;
          transform: scaleX(-1);
        }
      }

      .button-number {
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
        letter-spacing: -0.02em;
      }

      &.route_person {
        background: #819f77;
        color: white;
      }

      &.route_group {
        background: #77a5d7;
        color: white;
      }

      &.voicemail {
        background: #6d67ac;
        color: white;
      }

      &.hang_up {
        background: #cc2f2f;
        color: white;
      }

      &.empty_route {
        background: white;
        color: #5b667b;
        border: 1.5px solid #5b667b;
      }
    }
  }
}
</style>
